import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const style: CSSResult = css`
  :host {
    display: block;
    width: 100%;
    --csc-store-location-text-color: ${csColorText.body};
  }

  #details {
    flex: 1;
    gap: ${csSpacing.spacing03};
  }

  #address cse-text,
  #phone,
  #opening-hours .opening-hours-grid cse-text {
    --cse-text-color: var(--csc-store-location-text-color);
  }

  #distance cse-icon {
    --cse-icon-color: ${csColorText.muted};
  }

  cse-image {
    flex-shrink: 0;
  }

  .opening-hours-wrapper {
    align-self: flex-start;
  }

  .opening-hours-sizer {
    visibility: hidden;
    height: 0;
    overflow: hidden;
  }

  #opening-hours {
    text-align: left;
  }

  .opening-hours-title {
    --cse-text-color: var(--cse-link-primary-color, ${csColorAction.linkPrimary});
    text-decoration-line: underline;
    text-decoration-color: var(--cse-link-primary-color, ${csColorAction.linkPrimary});
    cursor: pointer;
  }

  .opening-hours-title:hover {
    --cse-text-color: var(--cse-link-primary-color-hover, ${csColorAction.linkPrimaryHover});
    text-decoration-color: var(--cse-link-primary-color-hover, ${csColorAction.linkPrimaryHover});
  }

  .opening-hours-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 ${csSpacing.spacing05};
  }
`
